import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AdminAppShell } from "../../../design-system/shells/AdminAppShell";
import { useAuth } from "../../../lib/auth";
import { api } from "../../../lib/api";
import { ProjectForm } from "../../../components/portfolio/ProjectForm";
import { Section } from "../../../components/portfolio/Section";
import { errMsg } from "../../../lib/portfolio";

export default function PortfolioNew() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const founder = user?.role_key === "OWNER_SUPER_ADMIN";
  const create = async (payload) => {
    setBusy(true);
    try {
      const r = await api.post("/admin/portfolio/projects", payload);
      toast.success("Project created as a draft.");
      navigate(`/admin/portfolio/${r.data.id}`, { replace: true });
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <AdminAppShell activeNav="portfolio" title="New portfolio project" user={user}
      subtitle="Starts as a private draft. Nothing is public until you publish."
      breadcrumbs={[{ label: "Portfolio Manager", to: "/admin/portfolio" }, { label: "New project", to: null }]}>
      <div className="max-w-3xl">
        {founder ? (
          <Section title="Project details" testId="portfolio-new-section">
            <ProjectForm onSubmit={create} busy={busy} submitLabel="Create draft" />
          </Section>
        ) : (
          <p className="text-sm font-nav text-erf-dark" role="alert" data-testid="portfolio-founder-only">Only the Founder can create projects.</p>
        )}
      </div>
    </AdminAppShell>
  );
}
